import Vue from 'vue';
import VueRouter from 'vue-router';
import DealerContent from '@/views/dealer-content.vue';
import SearchHub from '@/views/search-hub.vue';
import TradeWalk from '@/views/trade-walk.vue';
import ViewVehicle from '@/views/view-vehicle.vue';
import FinanceProducts from '@/views/finance-products.vue';

Vue.use(VueRouter);

const routes = [
  // TODO: Update to lazy loaded routes after fixing conflicts with lifecycle hooks (created).
  {
    path: '/dealer-content/',
    name: 'dealer-content',
    component: DealerContent,
  },
  {
    path: '/search-hub/',
    name: 'search-hub',
    component: SearchHub,
  },
  {
    path: '/trade-walk/',
    name: 'trade-walk',
    component: TradeWalk,
  },
  {
    path: '/view-vehicle/',
    name: 'view-vehicle',
    component: ViewVehicle,
  },
  {
    path: '/finance-products/',
    name: 'finance-products',
    component: FinanceProducts,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
